// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609232013/js/" + chunkId + "." + {"44":"69ac218c","225":"dc4493a3","481":"1162a410","486":"9f466e82","770":"d44611ea"}[chunkId] + ".0.08623534880481509.chunk.js";
};